<form [formGroup]="form">
  <div class="row mb-4">
    <div class="col-md-12">
      <label class="required">{{'Cancel Action' |
        translate}}</label>
      <div>
        <ng-container *ngFor="let activity of cancelActions">
          <ng-container *ngIf="activity.access">
            <input
              class="form-check-input"
              type="checkbox"
              [id]="activity.key_trans"
              [disabled]="isLocked"
              [checked]="activity.value === form.controls.cancelled_action.value"
              [value]="activity.value"
              (change)="onChangeCancelAction(activity.value)"
            >
            <label
              class="form-check-label text-value"
              [for]="activity.key_trans"
            >
              {{activity.name | translate}}
            </label>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="form-group mb-5">
    <label
      for="reason"
      class="required"
    >{{'Reason for Cancellation' | translate}}</label>
    <textarea
      class="form-control"
      [class.no-resize]="isLocked"
      id="reason"
      rows="3"
      placeholder=""
      formControlName="cancelled_reason"
    ></textarea>
  </div>
</form>
